import Product from "../../../../../@types/Product";

const LiftKitsE4: Product[] = [
    {
        id: 1,
        name: 'Lifted',
        sku: 'L',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/liftkit/lifted.jpg`,
        price: 300.00,
        retailPrice: 500.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/a4e7d2be-4be0-4778-b996-872afcd47200'
    },
    {
        id: 2,
        name: 'Non-lifted',
        sku: 'NL',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/liftkit/nonlifted.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/23c91300-8f38-4629-7ab8-82d516ba2200'
    }
]

export { LiftKitsE4 };